import { render, staticRenderFns } from "./AttachmentItem.vue?vue&type=template&id=aa211468&scoped=true&"
import script from "./AttachmentItem.vue?vue&type=script&lang=js&"
export * from "./AttachmentItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa211468",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/whatsapp-crm-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa211468')) {
      api.createRecord('aa211468', component.options)
    } else {
      api.reload('aa211468', component.options)
    }
    module.hot.accept("./AttachmentItem.vue?vue&type=template&id=aa211468&scoped=true&", function () {
      api.rerender('aa211468', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TeamInbox/AttachmentItem.vue"
export default component.exports